import React, { useState, useEffect, useRef } from 'react';
import {
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';
import { Scatter } from 'react-chartjs-2';
import { useDiagnostico } from '../../../context/DiagnosticoContext/DiagnosticoHook';

ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);
const ChartScatter = ({
  dataChart,
  textoPosicionY,
  textoPosicionX,
  currentAnswer,
  indiceGrupoActual,
  textoIntermedio,
}) => {
  if (
    !dataChart ||
    dataChart.length === 0 ||
    !indiceGrupoActual ||
    !textoIntermedio
  ) {
    return null;
  }

  const [loadChart, setloadChart] = useState(false);
  const { setChatStateFn, setLoadingTextFn } = useDiagnostico();
  const chartRef = useRef();
  const chartData = {
    datasets: [
      {
        label: 'Tú',
        data: [
          {
            x: currentAnswer[0],
            y: currentAnswer[1],
          },
        ],
        backgroundColor: 'rgba(236,37,37,0.6)',
        pointStyle: 'rectRot', // Puedes cambiar 'circle' por 'rect', 'rectRounded', 'rectRot', 'cross', 'crossRot', 'star', 'line', 'dash'
        pointRadius: 7, // Cambia el número para ajustar el tamaño del punto
      },
      {
        label: 'Otras empresas',
        data: dataChart.map((item) => ({
          x: item.pregunta0,
          y: item.pregunta1,
        })),
        backgroundColor: 'rgba(154,101,235,0.47)',
      },
    ],
  };

  useEffect(() => {
    if (loadChart) {
      // Si loadChart es verdadero, captura la imagen actual del gráfico como una cadena base64.
      const base64Image = chartRef.current.canvas.toDataURL('image/jpg');
      // Llama a setChatStateFn con la imagen capturada, almacenándola en un estado global o local.
      setChatStateFn({
        chart: { [`captura${indiceGrupoActual}`]: base64Image },
      });
    }
  }, [loadChart]); // Este efecto depende de loadChart, ejecutándos

  const options = {
    responsive: true, // Hace que el gráfico sea responsivo al tamaño de su contenedor.
    maintainAspectRatio: false, // Permite que el gráfico ignore el aspect ratio de su contenedor para un mejor ajuste.
    scales: {
      x: {
        beginAtZero: true, // Comienza el eje X desde cero.
        title: {
          display: true, // Muestra un título para el eje X.
          text: textoPosicionX ? [textoPosicionX] : [''], // Texto del título, condicional en base a textoPosicionX.
        },
        grid: {
          display: true, // Oculta la cuadrícula del eje X para un diseño más limpio.
        },
      },
      y: {
        beginAtZero: true, // Comienza el eje Y desde cero.
        title: {
          display: true, // Muestra un título para el eje Y.
          text: textoPosicionY ? [textoPosicionY] : [''], // Texto del título, condicional en base a textoPosicionY.
        },
        grid: {
          display: true, // Oculta la cuadrícula del eje Y para un diseño más limpio.
        },
      },
    },
    plugins: {
      tooltip: {
        enabled: false, // Deshabilita los tooltips para simplificar la visualización.
      },
    },
    animation: {
      // Función que se llama automáticamente cuando la animación del gráfico se completa.
      onComplete: function () {
        // Verifica si el ref del gráfico y su canvas están disponibles para evitar errores.
        if (chartRef.current && chartRef.current.canvas) {
          // Establece loadChart a true, desencadenando el useEffect para capturar la imagen del gráfico.
          setloadChart(true);
          setLoadingTextFn(true);
        }
      },
    },
  };

  return (
    <div className="contenedorGrafica">
      {chartData.datasets[1].data[0].x !== undefined &&
        chartData.datasets[1].data[0].y !== undefined && (
          <Scatter
            width={'100%'}
            height={'100%'}
            options={options}
            data={chartData}
            ref={chartRef}
          />
        )}
    </div>
  );
};

export default ChartScatter;
